/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Overview_Start_RoundInputs */



/**
* | output |
* | --- |
* | "Start Round {n}" |
*
* @param {Overview_Start_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_start_round = /** @type {((inputs: Overview_Start_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Start_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Commencer la ronde ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Iniciar ronda ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Iniciar Rodada ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inizia Round ${i?.n}`)
	return /** @type {LocalizedString} */ (`Start Round ${i?.n}`)
});